import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Select } from 'antd';
import { getDetailCodebase } from 'redux/actions/daoUI/codebase.action';
import { getListBountyByDao } from 'redux/actions/daoUI/bounty.action';
import { getListChallengeByBounty } from 'redux/actions/daoUI/challenges.action';
import { getListTeamsByBounty } from 'redux/actions/daoUI/teamBounties.action';
import AwsFileUpload from 'views/components/core/AwsFileUpload';

const { TextArea } = Input;
const { Option } = Select;

const GeneralTab = ({ editedCodebase, onSave, onCancel, isCreateMode, daoId, chainId }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [banner, setBanner] = useState('');
  const [thumbnail, setThumbnail] = useState('');
  const [bounties, setBounties] = useState([]);
  const [challenges, setChallenges] = useState([]);
  const [teams, setTeams] = useState([]);
  const bannerRef = useRef();
  const thumbnailRef = useRef();

  useEffect(() => {
    const fetchCodebaseDetails = async () => {
      if (editedCodebase?._id) {
        const response = await getDetailCodebase(editedCodebase._id)();
        console.log('response', response);
        if (response?.data) {
          form.setFieldsValue({
            name: response.data.name,
            challenges: response.data.challenges,
            devTeams: response.data.devTeams,
            bounty: response.data.bounty,
            bountyId: response.data.bountyId,
            challengeId: response.data.challengeId,
            devTeamId: response.data.devTeamId,
            daoId: response.data.daoId,
            shortDescription: response.data.shortDescription
          });
          setBanner(response.data.banner || '');
          setThumbnail(response.data.thumbnail || '');
          
          // Fetch challenges and teams for initial bounty if exists
          if (response.data.bountyId) {
            fetchChallenges(response.data.bountyId);
            fetchTeams(response.data.bountyId);
          }
        }
      }
    };

    fetchCodebaseDetails();
  }, [editedCodebase?._id, form]);

  useEffect(() => {
    const fetchBounties = async () => {
      if (daoId) {
        const params = {
          daoId,
          chainId: chainId,
          page: 1,
          limit: 1000
        };
        const response = await getListBountyByDao(params)();
        if (response?.data) {
          setBounties(response.data);
        }
      }
    };

    fetchBounties();
  }, [daoId, chainId]);

  const fetchChallenges = async (bountyId) => {
    if (bountyId) {
      const params = {
        bountyId,
        page: 1,
        limit: 1000
      };
      const response = await getListChallengeByBounty(params)();
      if (response?.data) {
        setChallenges(response.data);
      } else {
        setChallenges([]);
      }
    } else {
      setChallenges([]);
    }
  };

  const fetchTeams = async (bountyId) => {
    if (bountyId) {
      const params = {
        bountyId,
        page: 1,
        limit: 1000
      };
      const response = await getListTeamsByBounty(params)();
      if (response?.data) {
        setTeams(response.data?.teams || []);
      } else {
        setTeams([]);
      }
    } else {
      setTeams([]);
    }
  };

  const handleBountyChange = async (value) => {
    form.setFieldsValue({ 
      bountyId: value, 
      challengeId: undefined,
      devTeamId: undefined 
    });
    await Promise.all([
      fetchChallenges(value),
      fetchTeams(value)
    ]);
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      await onSave(values);
    } finally {
      setSubmitting(false);
    }
  };

  const handleUploadDone = (field) => (url) => {
    if (field === 'banner') setBanner(url);
    if (field === 'thumbnail') setThumbnail(url);
  };

  return (
    <div style={{ flex: 1 }}>
      <div style={{ display: 'flex', gap: 32 }}>
        {/* Left Column */}
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Name <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              placeholder="Huy Test"
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                fontSize: '14px'
              }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Challenges
            </label>
            <select
              value={form.getFieldValue('challengeId')}
              onChange={(e) => form.setFieldValue('challengeId', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                fontSize: '14px',
                backgroundColor: 'white'
              }}
              disabled={!form.getFieldValue('bountyId')}
            >
              <option value="">Select a challenge</option>
              {challenges.map((challenge) => (
                <option key={challenge._id} value={challenge._id}>
                  {challenge.name || challenge.title}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Dev Teams <span style={{ color: 'red' }}>*</span>
            </label>
            <select
              value={form.getFieldValue('devTeamId')}
              onChange={(e) => form.setFieldValue('devTeamId', e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                fontSize: '14px',
                backgroundColor: 'white'
              }}
              disabled={!form.getFieldValue('bountyId')}
            >
              <option value="">Select a team</option>
              {teams.map((team) => (
                <option key={team._id} value={team._id}>
                  {team.name || team.teamName}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Banner <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              {banner && (
                <img 
                  src={banner} 
                  alt="Banner" 
                  style={{ 
                    width: 220, 
                    height: 73, 
                    objectFit: 'cover', 
                    borderRadius: 4,
                    border: '1px solid #e0e0e0'
                  }} 
                />
              )}
              <button
                type="button"
                onClick={() => bannerRef.current.click()}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #1976d2',
                  borderRadius: 4,
                  backgroundColor: 'white',
                  color: '#1976d2',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Chọn ảnh
              </button>
              <AwsFileUpload
                customStyle={{ display: 'none' }}
                fileRef={bannerRef}
                accept=".png, .jpg, .jpeg, .webp"
                typePattern={/^image\/(png|jpg|jpeg|webp)$/}
                maxSize={5}
                path="codebase/banner/"
                prefix="banner_"
                uploadDone={handleUploadDone('banner')}
              />
            </div>
            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
              Banner (1500×500, WEBP recommended) *
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div style={{ flex: 1 }}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Bounty
            </label>
            <select
              value={form.getFieldValue('bountyId')}
              onChange={(e) => handleBountyChange(e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                fontSize: '14px',
                backgroundColor: 'white'
              }}
            >
              <option value="">Select a bounty</option>
              {bounties.map((bounty) => (
                <option key={bounty._id} value={bounty._id}>
                  {bounty.name || bounty.title}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Dao
            </label>
            <select
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                fontSize: '14px',
                backgroundColor: 'white'
              }}
            >
              <option value="Tech Elderly Care Dao BSC 2 - TECB">Tech Elderly Care Dao BSC 2 - TECB</option>
            </select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Short Description <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              placeholder="Ngay từ thiết kế, anh em đã thấy được hơi thở của chiếc 58mm f/0.95 Noct đâu đây nhưng Plena là một"
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: 4,
                fontSize: '14px'
              }}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', marginBottom: 4, color: '#666' }}>
              Thumbnail <span style={{ color: 'red' }}>*</span>
            </label>
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              {thumbnail && (
                <img 
                  src={thumbnail} 
                  alt="Thumbnail" 
                  style={{ 
                    width: 140, 
                    height: 100, 
                    objectFit: 'cover', 
                    borderRadius: 4,
                    border: '1px solid #e0e0e0'
                  }} 
                />
              )}
              <button
                type="button"
                onClick={() => thumbnailRef.current.click()}
                style={{
                  padding: '8px 16px',
                  border: '1px solid #1976d2',
                  borderRadius: 4,
                  backgroundColor: 'white',
                  color: '#1976d2',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Chọn ảnh
              </button>
              <AwsFileUpload
                customStyle={{ display: 'none' }}
                fileRef={thumbnailRef}
                accept=".png, .jpg, .jpeg, .webp"
                typePattern={/^image\/(png|jpg|jpeg|webp)$/}
                maxSize={5}
                path="codebase/thumbnail/"
                prefix="thumbnail_"
                uploadDone={handleUploadDone('thumbnail')}
              />
            </div>
            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
              Thumbnail (696 x 500, WEBP recommended) *
            </div>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 24, justifyContent: 'flex-start' }}>
        <button
          onClick={handleSubmit}
          style={{
            padding: '8px 16px',
            backgroundColor: '#00ffe0',
            color: '#181c22',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          {submitting ? 'Saving...' : (isCreateMode ? 'Create' : 'Update')}
        </button>
        <button
          onClick={onCancel}
          style={{
            padding: '8px 16px',
            backgroundColor: '#f5f5f5',
            color: '#666',
            border: '1px solid #d9d9d9',
            borderRadius: 4,
            cursor: 'pointer'
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default GeneralTab; 